import React from 'react';
import { Button, Input, } from 'reactstrap';
import { useToggle } from 'react-use';
import classnames from 'classnames';
import { toast } from 'react-toastify';

import firebase from '../firebase';
import { resizeImage } from '../util';

const storageRef = firebase.storage().ref();

export default function FilesUploadButton (props) {
  const { storagePath = '', path = _ => props.storagePath + '/' + (new Date()).getTime(), multiple = true, accept, onUploaded = _ => _, disabled = false, validate = _ => true, ...extraProps } = props;
  const [isImporting, toggleImporting] = useToggle(false);
  const onSelectFiles = async ({ target, target: { files } }) => {
    if(files.length === 0) return;
    if(!validate(files)) return;

    toggleImporting(true);
    try {
      const uploads = await Array.from(files).reduce(async (x, file) => {
        const prevs = await x;
        const _path = path(file);
        const fileRef = storageRef.child(_path);
        await fileRef.put(file, { contentType: file.type });
        const downloadUrl = await fileRef.getDownloadURL();

        let thumbnailUrl;
        if (file.type.match(/^image/)) {
          const resizedFile = await resizeImage(file, 800);
          const pathParts = _path.split('/');
          const fileName = pathParts[pathParts.length - 1];
          const dirPath = pathParts.slice(0, -1).join('/');
          const thumbPath = `${dirPath}/thumb_800_${fileName}`;
          const thumbRef = storageRef.child(thumbPath);
          await thumbRef.put(resizedFile, { contentType: file.type });
          thumbnailUrl = await thumbRef.getDownloadURL();
        }

        return [...prevs, { path: _path, file, fileRef, downloadUrl, thumbnailUrl }];
      }, Promise.resolve([]));
      await onUploaded(uploads);
      toast.success('アップロードしました');
    } catch(e) {
      console.error(e);
      toast.error('アップロードに失敗しました');
    }
    toggleImporting(false);
    target.value = '';
  };

  return (
    <Button color="secondary" disabled={isImporting || disabled} {...extraProps}>
      <label className="m-0 cursor-pointer">
        <span className={classnames('fas', { 'fa-upload': !isImporting, 'fa-spin fa-spinner': isImporting})} />
        <Input multiple={multiple} type="file" className="d-none" onChange={onSelectFiles} accept={accept} disabled={disabled} />
      </label>
    </Button>
  );
};
